export const fileTypeCheck = [
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
];
export const fileTypePDF = [
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
];
export const fileTypewordPDF = [
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'application/pdf',
  'application/PDF',
];

export const AllType = [
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/msword',
  'application/pdf',
  'application/PDF',
  'image/png',
  'image/jpg',
  'image/jpeg',
];

export const resumeStatusToBgColor: Record<string, string> = {
  S: '#D0FFE8',
  R: '#FDEDE9',
  OA: '#D0FFE8',
  OR: '#FDEDE9',
  J: '#D0FFE8',
  JD: '#D0FFE8',
  B: '#D0FFE8',
  NJ: '#FDEDE9',
};
export enum InterviewLevel {
  FirstInterview = 'firstInterview',
  SecondInterview = 'secondInterview',
  ThirdInterview = 'thirdInterview',
  FourthInterview = 'fourthInterview',
  FinalInterview = 'finalInterview',
}
export const InterviewLevelToText: Record<InterviewLevel, string> = {
  [InterviewLevel.FirstInterview]: 'First Interview',
  [InterviewLevel.SecondInterview]: 'Second Interview',
  [InterviewLevel.ThirdInterview]: 'Third Interview',
  [InterviewLevel.FourthInterview]: 'Fourth Interview',
  [InterviewLevel.FinalInterview]: 'Final Interview',
};
export const Resumetatus: any = [
  {
    label: 'CRM Validation Pending',
    value: 'inReview',
  },
  {
    label: 'CRM Validated',
    value: 'approved',
  },
  {
    label: 'CRM Rejected',
    value: 'rejected',
  },
  {
    label: 'CV Sent/Feedback Awaiting',
    value: 'FA',
  },
  {
    label: 'Shortlisted',
    value: 'S',
  },
  {
    label: 'CV Rejected',
    value: 'R',
  },
  {
    label: 'Interview Scheduled',
    value: 'IS',
  },
  {
    label: 'Interview Selected',
    value: 'interviewSelected',
  },
  {
    label: 'Interview Rejected',
    value: 'interviewRejected',
  },
  {
    label: 'Offer Pending',
    value: 'OP',
  },
  {
    label: 'Joined',
    value: 'J',
  },
  {
    label: 'Not Joined',
    value: 'NJ',
  },
  {
    label: 'Deffered',
    value: 'JD',
  },
  {
    label: 'Billed',
    value: 'B',
  },
  {
    label: 'Draft',
    value: 'draft',
  },
];
export const InterviewStatus: any = [
  {
    label: 'Interview Scheduled',
    value: 'IS',
  },
  {
    label: 'Interview Selected',
    value: 'interviewSelected',
  },
  {
    label: 'Interview Rejected',
    value: 'interviewRejected',
  },
  {
    label: 'Offer Pending',
    value: 'OP',
  },
  {
    label: 'Joined',
    value: 'J',
  },
  {
    label: 'Not Joined',
    value: 'NJ',
  },
  {
    label: 'Deffered',
    value: 'JD',
  },
  {
    label: 'Billed',
    value: 'B',
  },
];
export const openingHandle = [
  { label: 'Monthly Opening(CTC)', value: 'ctcWise' },
  { label: 'Client Opening(CTC)', value: 'clientWise' },
  { label: 'Client Opening(Month)', value: 'monthWise' },
];
export const CvStatus = [
  { label: 'CTC Wise CV Status', value: 'ctcWise' },
  { label: 'Client Wise CV Status', value: 'clientWise' },
  { label: 'Month Wise CV Status', value: 'monthWise' },
];
export const TaktTime = [{ label: 'CTC Wise', value: 'ctcWise' }];
export const Productivity = [{ label: 'CTC Wise', value: 'ctcWise' }];
export const BusinessConversion = [
  { label: 'Employee', value: 'employee' },
  { label: 'Client', value: 'client' },
];
export const totalOpenings = [
  { label: 1, value: '1' },
  { label: 2, value: '2' },
  { label: 3, value: '3' },
  { label: 4, value: '4' },
  { label: 5, value: '5' },
  { label: 6, value: '6' },
  { label: 7, value: '7' },
  { label: 8, value: '8' },
  { label: 9, value: '9' },
  { label: 10, value: '10' },
  { label: 11, value: '11' },
  { label: 12, value: '12' },
  { label: 13, value: '13' },
  { label: 14, value: '14' },
  { label: 15, value: '15' },
  { label: 16, value: '16' },
  { label: 17, value: '17' },
  { label: 18, value: '18' },
  { label: 19, value: '19' },
  { label: 20, value: '20' },
  { label: 21, value: '21' },
  { label: 22, value: '22' },
  { label: 23, value: '23' },
  { label: 24, value: '24' },
  { label: 25, value: '25' },
  { label: 26, value: '26' },
  { label: 27, value: '27' },
  { label: 28, value: '28' },
  { label: 29, value: '29' },
  { label: 30, value: '30' },
  { label: 31, value: '31' },
  { label: 32, value: '32' },
  { label: 33, value: '33' },
  { label: 34, value: '34' },
  { label: 35, value: '35' },
  { label: 36, value: '36' },
  { label: 37, value: '37' },
  { label: 38, value: '38' },
  { label: 39, value: '39' },
  { label: 40, value: '40' },
  { label: 41, value: '41' },
  { label: 42, value: '42' },
  { label: 43, value: '43' },
  { label: 44, value: '44' },
  { label: 45, value: '45' },
  { label: 46, value: '46' },
  { label: 47, value: '47' },
  { label: 48, value: '48' },
  { label: 49, value: '49' },
  { label: 50, value: '50' },
];
export const interviewSechdule = ['ISA', '2ISA', '3ISA', '4ISA', '5ISA'];
export const interviewResechdule = ['1IS', '2IS', '3IS', '4IS', '5IS'];
export const interviewDirectSelect = ['ISA', 'S', 'R'];
export const interviewSelectReject = ['S', 'R'];

export enum ResumeStatusType {
  APPROVAL = 'approval', // resume approve/reject status type
  SCREENING = 'screening',
  INTERVIEW = 'interview',
  INPROCESS = 'inProgress',
  OFFER = 'offer',
  JOINING = 'joining',
  BILLING = 'billing',
  L1BillingAppoval = 'l1BillingApproval',
  L2BillingAppoval = 'finalBillingApproval',
  BhBillingAppoval = 'BhBillingApproval',
}

export enum ResumeApprovalStatus {
  InReview = 'inReview',
  Approved = 'approved',
  Rejected = 'rejected',
  Draft = 'draft',
}

export enum ScreeningStatus {
  SHORTLISTED = 'S',
  REJECTED = 'R',
}
export const RejetedStatus = ['R', 'OR', 'NJ', 'rejected'];

export enum MailBoxType {
  SendCvToClient = 'sendCvToClient',
  InterviewConfirmationToClient = 'interviewConfirmationToClient',
  InterviewConfirmationToCandidate = 'interviewConfirmationToCandidate',
}

export const mailBoxTypeToText: Record<MailBoxType, string> = {
  [MailBoxType.SendCvToClient]: 'Send CV to client',
  [MailBoxType.InterviewConfirmationToClient]: 'Interview Confirmation to Client',
  [MailBoxType.InterviewConfirmationToCandidate]: 'Schedule Interview to Candidates',
};

export const AccessDenied = 'Access is Denied, Please Contact Administrator for the Access';

export const getResumeStatus = (
  approvalStatus: string,
  cvSent?: boolean,
  resumeStatusType?: string,
  resumeStatus?: string,
) => {
  switch (approvalStatus) {
    case ResumeApprovalStatus.Approved:
      if (resumeStatusType) {
        if (cvSent) {
          if (resumeStatusType === ResumeStatusType.INTERVIEW) {
            if (resumeStatus === 'R') {
              return 'Interview Rejected';
            }
            return 'Interview Scheduled';
          } else if (resumeStatusType === ResumeStatusType.SCREENING) {
            if (resumeStatus === ScreeningStatus.SHORTLISTED) {
              return 'CV Shortlisted';
            } else if (resumeStatus === ScreeningStatus.REJECTED) {
              return 'CV Rejected';
            }
          } else if (resumeStatusType === ResumeStatusType.OFFER) {
            return 'Offer Pending';
          }
          return 'CV Sent';
        } else if (resumeStatusType === ResumeStatusType.APPROVAL) {
          if (resumeStatus === ResumeApprovalStatus.Approved) {
            return 'CRM Validated';
          }
        }
      }
      break;
    case ResumeApprovalStatus.Rejected:
      return 'CRM Rejected';
    case ResumeApprovalStatus.InReview:
      return 'CRM Validation Pending';
    case ResumeApprovalStatus.Draft:
      return 'Draft';
    default:
      return '-';
  }
};

const billingStatusToText = (status: string, color?: boolean): string => {
  switch (status) {
    case 'B':
      return color ? '#52E0E0' : 'Billed';
    default:
      return color ? '#77F36E' : 'Joined';
  }
};

const joiningStatusToText = (status: string, color?: boolean): string => {
  switch (status) {
    case 'J':
      return color ? '#77F36E' : 'Joined';
    case 'JD':
      return color ? '#C79767' : 'Joining Deferred';
    case 'NJ':
      return color ? '#CBF340' : 'Not Joined';
    default:
      return color ? '#33AAFF' : 'Offer Accepted';
  }
};

const offerStatusToText = (status: string, color?: boolean): string => {
  switch (status) {
    case 'OA':
      return color ? '#33AAFF' : 'Offer Accepted';
    case 'OR':
      return color ? '#FFBDED' : 'Offer Rejected';
    default:
      return color ? '#008FFB' : 'Offer Pending';
  }
};

const interviewStatusToText = (status: string, color?: boolean): string => {
  switch (status) {
    case '5IS':
    case '4IS':
    case '3IS':
    case '2IS':
    case '1IS':
      return color ? '#F59E0B' : 'Interview Scheduled';
    case '2ISA':
      return color ? '#F042BC' : '1st round selected';
    case '3ISA':
      return color ? '#F042BC' : '2nd round selected';
    case '4ISA':
      return color ? '#F042BC' : '3rd round selected';
    case '5ISA':
      return color ? '#F042BC' : '4th round selected';
    case 'R':
      return color ? '#F3733F' : 'Interview Rejected';
    case 'S':
      return color ? '#F042BC' : 'Interview Selected';
    default:
      return color ? '#5CC8BE' : 'CV Shortlisted';
  }
};

const screeningStatusToText = (status: string, color?: boolean): string => {
  switch (status) {
    case ScreeningStatus.SHORTLISTED:
      return color ? '#5CC8BE' : 'CV Shortlisted';
    case ScreeningStatus.REJECTED:
      return color ? '#AF52DE' : 'CV Rejected';
    default:
      return color ? '#F7CB45' : 'CV Sent';
  }
};

const crmStatusToText = (status: string, color?: boolean): string => {
  switch (status) {
    case 'approved':
      return color ? '#008FFB' : 'CRM Validated';
    case 'rejected':
      return color ? '#F59E0B' : 'CRM Rejected';
    default:
      return color ? '#F042BC' : 'CRM Validation Pending';
  }
};
export const currentResumeStatus = (resumeStatus: any[], color?: boolean): string | null => {
  const billing = resumeStatus.find((r) => r.type === ResumeStatusType.BILLING);
  const joining = resumeStatus.find((r) => r.type === ResumeStatusType.JOINING);
  const offer = resumeStatus.find((r) => r.type === ResumeStatusType.OFFER);
  const interview = resumeStatus.find((r) => r.type === ResumeStatusType.INTERVIEW);
  const screening = resumeStatus.find((r) => r.type === ResumeStatusType.SCREENING);
  const approval = resumeStatus.find((r) => r.type === ResumeStatusType.APPROVAL);
  if (billing && billing.status != 'BP') {
    return billingStatusToText(billing.status, color);
  }
  if (joining) {
    return joiningStatusToText(joining.status, color);
  }
  if (offer) {
    return offerStatusToText(offer.status, color);
  }
  if (interview) {
    return interviewStatusToText(interview.status, color);
  }
  if (screening) {
    return screeningStatusToText(screening.status, color);
  }
  if (approval) {
    return crmStatusToText(approval.status, color);
  }

  return null;
};
export const getRecruitmentStageValue = (key: string) => {
  switch (key) {
    case 'clientWorked':
      return 'Clients Worked';
    case 'openingWorked':
      return 'Openings Worked';
    case 'cvSent':
      return 'CV Sent';
    case 'cvShortlisted':
      return 'CV Shortlisted';
    case 'cvRejected':
      return 'CV Rejected';
    case 'cvFeedbackAwaited':
      return 'CV Feedback Awaited';
    case 'interviewScheduledAwaited':
      return 'Interview Schedule Awaited';
    case 'preliminaryInterviewsAttended':
      return 'Preliminary Interviews Attended';
    case 'finalInterviewAttended':
      return 'Final Interview Attended';
    case 'offerPending':
      return 'Offer Pending';
    case 'offerAccepted':
      return 'Offer Accepted';
    case 'offerRejected':
      return 'Offer Rejected';
    case 'joiningAwaited':
      return 'Joining Awaited';
    case 'joined':
      return 'Joined';
    case 'notJoined':
      return 'Not Joined';
    case 'joiningDeferred':
      return 'Joining Deferred';
    case 'billingPending':
      return 'Billing Pending';
    case 'openingsBilled':
      return 'Billed';
    default:
      return '-';
  }
};

export const currentResumeReason = (resumeStatus: any[]): string | null => {
  const billing = resumeStatus.find((r) => r.type === ResumeStatusType.BILLING);
  const joining = resumeStatus.find((r) => r.type === ResumeStatusType.JOINING);
  const offer = resumeStatus.find((r) => r.type === ResumeStatusType.OFFER);
  const interview = resumeStatus.find((r) => r.type === ResumeStatusType.INTERVIEW);
  const screening = resumeStatus.find((r) => r.type === ResumeStatusType.SCREENING);
  const approval = resumeStatus.find((r) => r.type === ResumeStatusType.APPROVAL);
  if (billing) {
    return billing.reason;
  }
  if (joining) {
    return joining.reason;
  }
  if (offer) {
    return offer.reason;
  }
  if (interview) {
    return interview.reason;
  }
  if (screening) {
    return screening.reason;
  }
  if (approval) {
    return approval.reason;
  }
  return null;
};

export const currentResumeStage = (resumeStatus: any[]): string | null => {
  const billing = resumeStatus.find((r) => r.type === ResumeStatusType.BILLING);
  const joining = resumeStatus.find((r) => r.type === ResumeStatusType.JOINING);
  const offer = resumeStatus.find((r) => r.type === ResumeStatusType.OFFER);
  const interview = resumeStatus.find((r) => r.type === ResumeStatusType.INTERVIEW);
  const screening = resumeStatus.find((r) => r.type === ResumeStatusType.SCREENING);
  const approval = resumeStatus.find((r) => r.type === ResumeStatusType.APPROVAL);
  if (billing) {
    return billing.status === 'BP' ? 'Joining' : 'Billing';
  }
  if (joining) {
    return joining.status === 'JA' ? 'Offer' : 'Joining';
  }
  if (offer) {
    return offer.status === 'OP' ? 'Interview' : 'Offer';
  }
  if (interview) {
    return interview.status === 'ISA' ? 'Screening' : 'Interview';
  }
  if (screening) {
    return screening.status === 'FA' ? 'CRM validation' : 'Screening';
  }
  if (approval) {
    return 'CRM validation';
  }
  return null;
};

export const resumeStatusTextToBgColor: Record<string, string> = {
  'CRM Validated': '#16C06E',
  'CRM Rejected': '#EE4B22',
  'CV Shortlisted': '#16C06E',
  'CV Rejected': '#EE4B22',
  'Interview Selected': '#16C06E',
  'Interview Scheduled': '#16C06E',
  'Interview Rejected': '#EE4B22',
  'Offer Accepted': '#16C06E',
  'Offer Rejected': '#EE4B22',
  Joined: '#16C06E',
  'Joining Deferred': '#16C06E',
  'Not Joined': '#EE4B22',
  Billed: '#16C06E',
};

export enum BillingStatus {
  BILLING_PENDING = 'BP',
  BILLED = 'B',
  L1ApprovalPending = 'l1ApprovalPending',
  L2ApprovalPending = 'finalApprovalPending',
  L1Approved = 'l1Approved',
  L2Approved = 'finalApproved',
  L1Rejected = 'l1Rejected',
  L2Rejected = 'finalRejected',
  BhApprovalPending = 'bhApprovalPending',
  BhApproved = 'bhApproved',
  BhRejected = 'bhRejected',
}
